import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';

import { TransferRequestDet } from '../../../common/model/TransferRequestDet';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { TransferRequestFacade } from '../../../common/facade/TransferRequestFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
@Component({
  selector: 'app-transfer-corporate-detail',
  templateUrl: './transfer-corporate-detail.component.html',
  styleUrls: ['./transfer-corporate-detail.component.css']
})
export class TransferCorporateDetailComponent implements OnInit {
  titleTransfer = res.Transfer
  lblDownload = res.Download;
  lblOrigin = res.Origin;
  lblDestination = res.Destination;
  lblCorporateDateRequested = res.CorporateDateRequested;
  lblWeek = res.Week;
  lblGender = res.Gender;
  lblStyle = res.Style;
  lblSeason = res.Season;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblBrand = res.Brand;
  lblStyleVariety = res.StyleVariety;
  lblSize = res.Size;
  lblRequested = res.Requested;
  lblSent = res.Sent;
  lblEntry = res.Entry;
  lblRejected = res.Rejected;
  lblReason = res.Reason;

  isSpanish = true;
  language = 0

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // info Header
  storeOriginName = '';
  storeDestinyName = '';
  requestedDate = '';
  week = '';
  sector = '';
  // Filtros
  gender = '-1';
  genders = [];
  style = '-1';
  styles = [];
  season = '-1';
  seasons = [];

  rows: TransferRequestDet[];
  private _filteredData: TransferRequestDet[];

  transferReqId = '';
  public extras: NavigationExtras;
  public path = '/transfer/corporate';

  public organizationSelected: any[] = [];
  strOrganizationSelected: string;
  txtStartDate = new Date();
  txtEndDate = new Date();
  storeOriginId = -1;
  storeDestinyId = -1;
  sectorId = -1;
  weekId = -1

  constructor(
    private _excel: ExcelUtility,
    private _transferRequestFacade: TransferRequestFacade,
    private _activatedRoute: ActivatedRoute,
    public strings: Strings
  ) { }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this._activatedRoute.queryParams.subscribe(params => {
      this.strOrganizationSelected = params['strOrganizationSelected'];
      this.txtStartDate = params['startDate'],
      this.txtEndDate = params['endDate'],
      this.storeOriginId = Number(params['storeOriginId']);
      this.storeDestinyId = Number(params['storeDestinyId']);
      this.sectorId = Number(params['sector']);
      this.weekId = Number(params['week']);

      this.extras = {
          queryParams: {
            'strOrganizationSelected': this.strOrganizationSelected,
            'startDate': this.txtStartDate,
            'endDate': this.txtEndDate,
            'storeOriginId': this.storeOriginId,
            'storeDestinyId': this.storeDestinyId,
            'sector': this.sectorId,
            'week': this.weekId,
          }
      };
    });

    if (!this.isSpanish) {
      this.language = 1
    }

    this.getTransferRequest();
  }

  private getTransferRequest() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this._transferRequestFacade.GetTransferRequestSummary(id).subscribe(
      response => {
        this.loading = false;
        this.rows = response.data.transferRequestDet;
        this._filteredData = response.data.transferRequestDet;
        this.gender = '-1';
        this.style = '-1';
        this.season = '-1';
        this.transferReqId = response.data.code;
        this.storeOriginName = response.data.storeOriginName;
        this.storeDestinyName = response.data.storeDestinationName;
        this.requestedDate = response.data.insertedDate;
        this.week = response.data.week.toString();
        this.sector = response.data.catDetSectorName;
        this.fillSpinners();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTransfersCouldNotBeObtained), 'danger');
      }
    );
  }

  private fillSpinners() {
    this._filteredData.forEach(x => {
      if (!this.genders.includes(x.genderName)) {
        this.genders.push(x.genderName);
      }
      if (!this.styles.includes(x.style)) {
        this.styles.push(x.style);
      }
      if (!this.seasons.includes(x.season.trim())) {
        this.seasons.push(x.season.trim());
      }
    });
  }


  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  // Filtros
  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  onGenderChange() {
    this.style = '-1';
    this.season = '-1';
    if (this.gender.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.genderName.toString() === this.gender.toString());
      });
    }
  }

  onStyleChange() {
    this.gender = '-1';
    this.season = '-1';
    if (this.style.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.style.toString() === this.style.toString());
      });
    }
  }

  onSeasonChange() {
    this.gender = '-1';
    this.style = '-1';
    if (this.season.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.season.toString() === this.season.toString());
      });
    }
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        const info = {
          [this.strings.GetText(res.Brand)]: row.brandName,
          [this.strings.GetText(res.Gender)]: row.genderName,
          [this.strings.GetText(res.Season)]: row.season,
          [this.strings.GetText(res.StyleVariety)]: row.styleVariety,
          [this.strings.GetText(res.Size)]: row.sizeName,
          [this.strings.GetText(res.Requested)]: row.quantity,
          [this.strings.GetText(res.Sent)]: row.quantitySend,
          [this.strings.GetText(res.Entry)]: row.quantityReceived,
          [this.strings.GetText(res.Rejected)]: row.quantityRejected,
          [this.strings.GetText(res.Reason)]: row.reasonRejected
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
    }
  }

}
